import { Space } from '@billy/design-system'
import { ReactElement } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { PurchaseVatRates } from './elements/PurchaseVatRates'
import { Rulesets } from './elements/Rulesets'
import { SalesVatRates } from './elements/SalesVatRates'

export const VatRatesSettings = (): ReactElement => {
  const { organization } = useUserOrganization()

  return (
    <>
      {organization?.source === 'billy' && (
        <>
          <Rulesets />
          <Space size="s24" />
        </>
      )}
      <SalesVatRates />
      <Space size="s24" />
      <PurchaseVatRates />
    </>
  )
}
